
import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { X, UserPlus, Save } from 'lucide-react';
import { UserRoleBadge } from './UserRoleBadge';
import RoleSelect from './Roleselect';
import { addUser, updateUser } from '../../../api/ApiUser';
import { useTranslation } from '../../../../TranslationContext';

interface UserFormModalProps {
  open: boolean;
  user: any;
  companyId: string;
  applicationId: string;
  onClose: () => void;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
}

const UserFormModal: React.FC<UserFormModalProps> = ({
  open,
  user,
  companyId,
  applicationId,
  onClose,
  onSuccess,
  onError,
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    role: [] as string[],
  });

  useEffect(() => {
    if (user) {
      setFormData({
        email: user.email,
        fullName: user.fullName,
        role: user.role || [],
      });
    } else {
      setFormData({
        email: '',
        fullName: '',
        role: [],
      });
    }
  }, [user]);
  
  // Fonction pour réinitialiser le formulaire
  const resetForm = () => {
    setFormData({
      email: '',
      fullName: '',
      role: [],
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (user) {
        // Logique pour la mise à jour d'un utilisateur
        await updateUser(companyId, applicationId, user.id, {
          fullName: formData.fullName
        });
        const message = t('user_updated_success');
        onSuccess(message);
      } else {
        // Logique pour l'ajout d'un nouvel utilisateur
        await addUser(companyId, applicationId, {
          fullName: formData.fullName,
          email: formData.email,
          roles: formData.role,
        });
        const message = t('user_added_success');
        onSuccess(message);
      }
      resetForm();
      onClose();
    } catch (error) {
      onError(t('error_user_action'));
    }
  };
  

  

  return (
      <Modal
        open={open}
        onCancel={onClose}
        title={
          <div className="flex items-center text-slate-700">
            {user ? t('edit_user') : t('new_user')}
          </div>
        }
        footer={null}
        width={500} 
        closeIcon={<X className="h-5 w-5 text-slate-400 hover:text-slate-600" aria-label={t('close')} />}
        className="user-form-modal"
      >
        <form onSubmit={handleSubmit} className="space-y-5 mt-4">
          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">{t('email')}</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="block w-full px-4 py-2.5 border border-slate-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition-all duration-200"
              required
              disabled={!!user}
              placeholder={t('email_placeholder')}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">{t('full_name')}</label>
            <input
              type="text"
              value={formData.fullName}
              onChange={(e) => setFormData({...formData, fullName: e.target.value})}
              className="block w-full px-4 py-2.5 border border-slate-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition-all duration-200"
              required
              placeholder={t('full_name_placeholder')}
            />
          </div>
          
          {/* N'afficher la sélection des rôles que lors de la création d'un nouvel utilisateur */}
          {!user && (
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">{t('roles')}</label>
              <RoleSelect
                selected={formData.role}
                onChange={(role) => setFormData({...formData, role})}
                applicationId={applicationId}
              />
              <div className="mt-3 flex flex-wrap gap-2">
                {formData.role.map((role) => (
                  <UserRoleBadge key={role} role={role} />
                ))}
              </div>
            </div>
          )}
          
          <div className="flex justify-end space-x-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-slate-600 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors duration-200"
            >
              {t('cancel')}
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-gray-500 rounded-lg hover:bg-gray-800 transition-colors duration-200 flex items-center"
            >
              {user ? (
                <>
                  <Save className="h-4 w-4 mr-1.5" />
                  {t('update')}
                </>
              ) : (
                <>
                  <UserPlus className="h-4 w-4 mr-1.5" />
                  {t('add')}
                </>
              )}
            </button>
          </div>
        </form>
      </Modal>
  
    // <Modal
    //   open={open}
    //   onCancel={onClose}
    //   title={
    //     <div className="flex items-center text-slate-700">
    //       {user ? t('edit_user') : t('new_user')}
    //     </div>
    //   }
    //   footer={null}
    //   width={500} 
    //   closeIcon={<X className="h-5 w-5 text-slate-400 hover:text-slate-600" aria-label={t('close')} />}
    //   className="user-form-modal"
    // >
    //   <form onSubmit={handleSubmit} className="space-y-5 mt-4">
    //     <div>
    //       <label className="block text-sm font-medium text-slate-600 mb-1">{t('email')}</label>
    //       <input
    //         type="email"
    //         value={formData.email}
    //         onChange={(e) => setFormData({...formData, email: e.target.value})}
    //         className="block w-full px-4 py-2.5 border border-slate-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition-all duration-200"
    //         required
    //         disabled={!!user}
    //         placeholder={t('email_placeholder')}
    //       />
    //     </div>
        
    //     <div>
    //       <label className="block text-sm font-medium text-slate-600 mb-1">{t('full_name')}</label>
    //       <input
    //         type="text"
    //         value={formData.fullName}
    //         onChange={(e) => setFormData({...formData, fullName: e.target.value})}
    //         className="block w-full px-4 py-2.5 border border-slate-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition-all duration-200"
    //         required
    //         placeholder={t('full_name_placeholder')}
    //       />
    //     </div>
        
    //     <div>
    //       <label className="block text-sm font-medium text-slate-600 mb-1">{t('roles')}</label>
    //       <RoleSelect
    //         selected={formData.role}
    //         onChange={(role) => setFormData({...formData, role})}
    //         applicationId={applicationId}
    //       />
    //       <div className="mt-3 flex flex-wrap gap-2">
    //         {formData.role.map((role) => (
    //           <UserRoleBadge key={role} role={role} />
    //         ))}
    //       </div>
    //     </div>
        
    //     <div className="flex justify-end space-x-3 pt-2">
    //       <button
    //         type="button"
    //         onClick={onClose}
    //         className="px-4 py-2 text-sm font-medium text-slate-600 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors duration-200"
    //       >
    //         {t('cancel')}
    //       </button>
    //       <button
    //         type="submit"
    //         className="px-4 py-2 text-sm font-medium text-white bg-gray-500 rounded-lg hover:bg-gray-800 transition-colors duration-200 flex items-center"
    //       >
    //         {user ? (
    //           <>
    //             <Save className="h-4 w-4 mr-1.5" />
    //             {t('update')}
    //           </>
    //         ) : (
    //           <>
    //             <UserPlus className="h-4 w-4 mr-1.5" />
    //             {t('add')}
    //           </>
    //         )}
    //       </button>
    //     </div>
    //   </form>
    // </Modal>
  );
};

export default UserFormModal;
